function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.35355 0.64644C4.15829 0.451178 3.84171 0.451178 3.64645 0.64644L0.464466 3.82842C0.269203 4.02368 0.269203 4.34027 0.464466 4.53553C0.659728 4.73079 0.97631 4.73079 1.17157 4.53553L4 1.7071L6.82843 4.53553C7.02369 4.73079 7.34027 4.73079 7.53553 4.53553C7.7308 4.34027 7.7308 4.02368 7.53553 3.82842L4.35355 0.64644ZM4.5 10.1538L4.5 0.999993L3.5 0.999993L3.5 10.1538L4.5 10.1538Z",
  fill: "#636363"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64645 15.3536C3.84171 15.5488 4.15829 15.5488 4.35355 15.3536L7.53553 12.1716C7.7308 11.9763 7.7308 11.6597 7.53553 11.4645C7.34027 11.2692 7.02369 11.2692 6.82843 11.4645L4 14.2929L1.17157 11.4645C0.976311 11.2692 0.659728 11.2692 0.464466 11.4645C0.269204 11.6597 0.269204 11.9763 0.464466 12.1716L3.64645 15.3536ZM3.5 2.07693L3.5 15H4.5L4.5 2.07693H3.5Z",
  fill: "#636363"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.1539,
  y: 1,
  width: 26.3846,
  height: 14,
  fill: "#636363"
});

function SvgKalinlikAraligiLevha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalinlikAraligiLevha);
export default __webpack_public_path__ + "static/media/kalinlik_araligi_levha.f72cfa07.svg";
export { ForwardRef as ReactComponent };